import { FunctionComponent } from 'react'
import { Control, FieldErrors } from 'react-hook-form'
import { ChildAgeRange } from '../../../gql/types'
import {
  childAgeRangeLocalizedString,
  childAgeRangeLocalizedStringInverse,
} from '../../../utils/GqlStrings'
import { childAgeRangeOptions } from '../../../utils/mappers'
import { MultiSelectWithExclusion } from '..'

interface IProps {
  name: string
  control: Control<any>
  errors?: FieldErrors<any>
  label?: string
  placeholder?: string
  required?: boolean
  menuPlacement?: 'auto' | 'bottom' | 'top'
  className?: string
}

const ChildrenSelector: FunctionComponent<IProps> = ({
  name,
  control,
  errors,
  // label = 'Do you have children? If yes, what are their age ranges?',
  // label='Do you have children? Select their age.'
  label = 'Do you have children? What ages?',
  placeholder = 'Select age ranges...',
  required = false,
  menuPlacement = 'auto',
  className = '',
}) => {
  return (
    <MultiSelectWithExclusion
      name={name}
      control={control}
      errors={errors}
      label={label}
      placeholder={placeholder}
      required={required}
      menuPlacement={menuPlacement}
      className={className}
      options={childAgeRangeOptions}
      localizedStringFn={childAgeRangeLocalizedString}
      localizedStringInverseFn={childAgeRangeLocalizedStringInverse}
      noneValue={ChildAgeRange.noChildren}
    />
  )
}

export { ChildrenSelector }
